import styles from "./index.module.scss";
import Stars from "../Stars";
import React from "react";

export default function Monitor(props: any) {
    return <div>
        {/*<div className={styles.monitorBg}></div>*/}
    <div className={styles.mpcWrapper}>
        <div className={styles.monitorWrapper}>


            <div className={styles.monitorBack}/>
            <div className={styles.monitorSide}/>

            <div className={styles.monitorBlock}>
                <div className={styles.monitorDisplayWrapper}>
                    <div className={styles.monitorDisplayInner}>
                        <Stars />
                    </div>
                </div>
            </div>

            <div className={styles.monitorFootWrapper}>
                <div className={styles.monitorFootBlock}>
                    <div className={styles.monitorFootTop} />
                </div>
                <div className={styles.monitorFootFront} />
                <div className={styles.monitorFootSide} />
            </div>

        </div>
    </div>
    </div>
}